import { cx } from "@ui/utils/cx";
import type { ReactNode } from "react";

export interface ButtonContentProps {
  children?: ReactNode;
  /** Extra classes on the content shell (e.g. `min-w-0` so inner truncation keeps working). */
  className?: string;
  /** Hides the content (without collapsing the button's size) so a `PendingOverlay` can take its place. */
  isPending?: boolean;
  leadIcon?: ReactNode;
  trailIcon?: ReactNode;
}

/**
 * Content shell shared by the styled button variants: lays out optional lead/trail
 * icons around the label using the button's own `gap`, and turns invisible while the
 * button is pending so the {@link PendingOverlay} spinner can take its place without
 * the button changing size.
 */
export function ButtonContent({ children, className, isPending, leadIcon, trailIcon }: ButtonContentProps) {
  return (
    <span className={cx("inline-flex items-center gap-[inherit]", isPending && "invisible", className)}>
      {leadIcon && (
        <span aria-hidden="true" className="inline-flex shrink-0">
          {leadIcon}
        </span>
      )}
      {children}
      {trailIcon && (
        <span aria-hidden="true" className="inline-flex shrink-0">
          {trailIcon}
        </span>
      )}
    </span>
  );
}
